/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */
import { auth } from '@util/interceptor';

import App from './App';
import Index from './components/Index';
import Login from './components/Login';
import Try from './components/Try';
import Test from './components/Test';
import flowRouter from './components/flow/router'; // 流程
import FinanceRouter from './components/finance/router'; // 财务
import AdministrativeRouter from './components/administrative/router'; // 行政
import TaskRouter from './components/task/router'; // 任务
import HrRouter from './components/hr/router'; // 人力资源
import BossRouter from './components/boss/router'; // 开发者中心
import HomeRouter from './components/home/router'; // 个人中心
import IncubatorRouter from './components/incubator/router'; // 孵化器中心
import CustomRouter from './components/custom/router'; // 孵化器中心
import NotFound from './components/NotFound';
import XianxingRouter from './components/xianxing/router'; // 先行管理
import CrmRouter from './components/crm/router'; // 华夏客户管理
import ClientRouter from './components/client/router'; // 帮实客户管理
import WorkflowRouter from './components/boss/workflow/router'; // 工作流
import resourceRouter from './components/resource/router'; // 工作流
import projectRouter from './components/project/router'; // 项目管理

const routers = {
  path: '/',
  onEnter: auth,
  component: App,
  breadcrumbName: '主页',
  indexRoute: {
    component: Index,
  },
  childRoutes: [
    {
      path: 'login',
      component: Login,
    },
    {
      path: 'try',
      component: Try,
    },
    {
      path: 'test',
      component: Test,
    },
    {
      path: '',
      component: Index,
      breadcrumbName: '决策系统',
      childRoutes: [
        HomeRouter,
        flowRouter,
        TaskRouter,
        FinanceRouter,
        HrRouter,
        BossRouter,
        IncubatorRouter,
        CustomRouter,
        XianxingRouter,
        CrmRouter,
        ClientRouter,
        WorkflowRouter,
        resourceRouter,
        AdministrativeRouter,
        projectRouter,
      ],
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
};

export default routers;



// WEBPACK FOOTER //
// ./src/routers.js